const WindowRepairInfo = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Bloc explicatif - Réparation de fenêtres et baies vitrées */}
        <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl shadow-xl p-8 border-l-4 border-emerald-600">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-tools-line text-3xl text-emerald-600"></i>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                La Réparation de Fenêtres et Baies Vitrées : Un Marché en Pleine Croissance
              </h2>
              <p className="text-gray-600 text-lg">
                Découvrez les opportunités de ce secteur porteur et les compétences recherchées
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Colonne gauche - Types d'interventions */}
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-hammer-line text-emerald-600 mr-2"></i>
                Types d'Interventions Courantes
              </h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Remplacement de vitrage</strong>
                    <p className="text-sm text-gray-600">Double ou triple vitrage cassé, fissuré ou embué</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Réparation de mécanismes</strong>
                    <p className="text-sm text-gray-600">Poignées, serrures, charnières et systèmes d'ouverture</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Rénovation de joints</strong>
                    <p className="text-sm text-gray-600">Amélioration de l'isolation thermique et phonique</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Ajustement et réglage</strong>
                    <p className="text-sm text-gray-600">Correction des problèmes d'ouverture et de fermeture</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Dépannage d'urgence</strong>
                    <p className="text-sm text-gray-600">Interventions rapides suite à effraction ou accident</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Colonne droite - Compétences et opportunités */}
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-star-line text-emerald-600 mr-2"></i>
                Compétences Recherchées
              </h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-emerald-600"></i>
                  <span className="text-gray-700">Maîtrise des techniques de pose et dépose</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-emerald-600"></i>
                  <span className="text-gray-700">Connaissance des matériaux (PVC, alu, bois)</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-emerald-600"></i>
                  <span className="text-gray-700">Diagnostic des problèmes d'étanchéité</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-emerald-600"></i>
                  <span className="text-gray-700">Respect des normes de sécurité</span>
                </div>
              </div>

              <div className="bg-white rounded-xl p-5 border border-emerald-200 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-lightbulb-line text-emerald-600 mr-2"></i>
                  Pourquoi Ce Secteur ?
                </h4>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <i className="ri-arrow-right-circle-fill text-emerald-600 mt-0.5 flex-shrink-0"></i>
                    <span><strong>Demande constante :</strong> Parc immobilier vieillissant nécessitant rénovation</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-arrow-right-circle-fill text-emerald-600 mt-0.5 flex-shrink-0"></i>
                    <span><strong>Rentabilité élevée :</strong> Interventions rapides avec marge intéressante</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-arrow-right-circle-fill text-emerald-600 mt-0.5 flex-shrink-0"></i>
                    <span><strong>Aides de l'État :</strong> MaPrimeRénov' stimule le marché</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-arrow-right-circle-fill text-emerald-600 mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fidélisation client :</strong> Clients satisfaits = recommandations</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Statistiques du marché */}
          <div className="mt-8 pt-6 border-t border-emerald-200">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-1">15M+</div>
                <div className="text-sm text-gray-600">Fenêtres à rénover en France</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-1">350€</div>
                <div className="text-sm text-gray-600">Panier moyen par chantier</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-1">+12%</div>
                <div className="text-sm text-gray-600">Croissance annuelle du secteur</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-1">24h</div>
                <div className="text-sm text-gray-600">Délai moyen d'intervention</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WindowRepairInfo;